import { api } from '../core';

export interface CaseAllegationGetUploadResponse {
  uploadPath: string;
  uploadToken: string;
  allegationDocumentId: string;
}

type CaseAllegationGetUploadProps = {
  caseId: string;
  documentName: string;
  documentFormat: string;
  sizeMb: number;
  isEdit: boolean;
};

const caseAllegationGetUploadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseAllegationGetUpload: builder.query<CaseAllegationGetUploadResponse, CaseAllegationGetUploadProps>({
      query: ({ caseId, documentName, documentFormat, sizeMb, isEdit }: CaseAllegationGetUploadProps) => ({
        url: `case/allegation/get-upload`,
        method: 'POST',
        body: {
          case_id: caseId,
          document_name: documentName,
          document_format: documentFormat,
          size_mb: sizeMb,
          isEdit: isEdit
        }
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getCaseAllegationGetUpload in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostCaseAllegationGetUploadQuery } = caseAllegationGetUploadApi;
